<div class="ods-panel">
  <div class="ods-panel__toolbar">
    <p class="ods-panel__counter" aria-live="polite">
      {{ selectedCount }} de {{ odsTotal }} ODS selecionados
    </p>

    <label class="ods-select-all">
      <span class="ods-select-all__label">Selecionar todos</span>
      <input
        class="ods-select-all__input"
        type="checkbox"
        role="switch"
        aria-label="Selecionar todos os ODS"
        [checked]="selectAll"
        (change)="onSelectAllToggle($event)" />
    </label>
  </div>

  <div class="ods-grid" role="group" aria-label="Objetivos de Desenvolvimento Sustentável">
    <button
      *ngFor="let item of odsItems; trackBy: trackByOdsId"
      type="button"
      class="ods-card"
      [class.ods-card--selected]="isSelected(item.id)"
      [attr.aria-pressed]="isSelected(item.id)"
      [attr.aria-label]="'ODS ' + item.id + ': ' + item.label"
      (click)="toggleOds(item.id)">
      <span class="ods-card__checkbox" [class.ods-card__checkbox--checked]="isSelected(item.id)" aria-hidden="true">
        <b3-icon *ngIf="isSelected(item.id)" name="check"></b3-icon>
      </span>

      <span class="ods-card__badge" [style.background-color]="item.color" aria-hidden="true">
        {{ item.id }}
      </span>

      <span class="ods-card__label">{{ item.label }}</span>
    </button>
  </div>
</div>
